export const LOGIN_TOKEN = 'loginToken';
export const AUTH_USER = 'calendarHeroUser';
export const AUTH_TOKEN = 'calendarHeroToken';

export const LOGIN_ROUTE = 'msg/outlook/loginurl';
export const TOKEN_ROUTE = 'msg/outlook/token';
export const EXCHANGE_ONLINE_AUTO_DISCOVERY_ROUTE = 'oauth/microsoft/domain';
export const EXCHANGE_LOGIN_ROUTE = 'user/e';

export const ADD_CONTACT_ROUTE = 'contact';
